/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* Closeout Connect collection category filter and mobile localization controls. */
(function () {
  var categoryDataRequests = new Map();

  function getCategoryDataUrl() {
    var url = new URL(window.location.href);

    url.searchParams.delete('page');
    url.searchParams.delete('section_id');

    Array.from(url.searchParams.keys()).forEach(function (key) {
      if (key.indexOf('filter.p.t.category') === 0) {
        url.searchParams.delete(key);
      }
    });

    url.searchParams.set('view', 'cc-category-filter-data');

    return url.toString();
  }

  function fetchCategoryDataPage(url, entries, pageCount) {
    if (pageCount > 100) {
      throw new Error('Category data exceeded the supported pagination depth.');
    }

    return fetch(url, { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) {
        throw new Error('Unable to load category data.');
      }

      return response.json();
    }).then(function (payload) {
      var pageEntries = Array.isArray(payload) ? payload : payload.entries;

      if (!Array.isArray(pageEntries)) {
        throw new Error('Invalid category data.');
      }

      Array.prototype.push.apply(entries, pageEntries);

      if (!Array.isArray(payload) && payload.next) {
        var nextUrl = new URL(payload.next, window.location.origin);
        nextUrl.searchParams.set('view', 'cc-category-filter-data');
        return fetchCategoryDataPage(nextUrl.toString(), entries, pageCount + 1);
      }

      return entries;
    });
  }

  function getCategoryData() {
    var url = getCategoryDataUrl();

    if (!categoryDataRequests.has(url)) {
      categoryDataRequests.set(url, fetchCategoryDataPage(url, [], 1).catch(function (error) {
        categoryDataRequests.delete(url);
        throw error;
      }));
    }

    return categoryDataRequests.get(url);
  }

  function sanitizeId(value) {
    return String(value).replace(/[^a-zA-Z0-9_-]/g, '-');
  }

  function isActiveCategory(activeValues, value) {
    return activeValues.indexOf(value) !== -1;
  }

  function createCheckIcon() {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');

    svg.setAttribute('viewBox', '0 0 16 16');
    svg.setAttribute('aria-hidden', 'true');
    path.setAttribute('d', 'M3 8.2 6.4 11.5 13 4.9');
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');
    path.setAttribute('stroke-width', '2.2');
    svg.appendChild(path);

    return svg;
  }

  function createCategoryChoice(paramName, context, category, count, active) {
    var item = document.createElement('li');
    var checkboxWrapper = document.createElement('div');
    var checkbox = document.createElement('input');
    var label = document.createElement('label');
    var categoryValue = category.filterValue || category.id;
    var categoryId = context.indexOf('desktop') === 0
      ? paramName + '-' + categoryValue
      : 'mobile-' + paramName + '-' + categoryValue;

    item.className = 'collection__filter-checkbox';
    checkboxWrapper.className = 'checkbox-wrapper';
    checkbox.className = 'checkbox' + (active ? ' is-selected' : '');
    checkbox.type = 'checkbox';
    checkbox.id = categoryId;
    checkbox.name = paramName;
    checkbox.value = categoryValue;
    checkbox.checked = active;
    checkboxWrapper.appendChild(checkbox);
    checkboxWrapper.appendChild(createCheckIcon());

    label.htmlFor = categoryId;
    label.appendChild(document.createTextNode(category.name + ' '));

    var countElement = document.createElement('span');
    countElement.className = 'cc-category-filter__count';
    countElement.textContent = '(' + count + ')';
    label.appendChild(countElement);

    item.appendChild(checkboxWrapper);
    item.appendChild(label);

    return item;
  }

  function groupCategories(entries) {
    var groups = new Map();

    entries.forEach(function (entry) {
      if (!entry || !entry.parent || !entry.parent.id || !entry.parent.name) {
        return;
      }

      var parent = groups.get(entry.parent.id);

      if (!parent) {
        parent = {
          id: entry.parent.id,
          name: entry.parent.name,
          count: 0,
          filterIds: new Set(),
          children: new Map()
        };
        groups.set(parent.id, parent);
      }

      parent.count += 1;

      if (entry.child && entry.child.id && entry.child.name) {
        parent.filterIds.add(entry.child.id);
        var child = parent.children.get(entry.child.id);

        if (!child) {
          child = { id: entry.child.id, name: entry.child.name, count: 0 };
          parent.children.set(child.id, child);
        }

        child.count += 1;
      } else {
        parent.filterIds.add(parent.id);
      }
    });

    return Array.from(groups.values()).sort(function (a, b) {
      return a.name.localeCompare(b.name);
    });
  }

  function renderCategoryFilter(container, entries) {
    var groups = groupCategories(entries);
    var activeValues = (container.dataset.activeValues || '').split('||').filter(Boolean);
    var paramName = container.dataset.filterParam;
    var context = container.dataset.ccCategoryFilter;

    container.replaceChildren();

    if (!groups.length) {
      var emptyMessage = document.createElement('p');
      emptyMessage.className = 'cc-category-filter__status';
      emptyMessage.textContent = 'No categories are available for these products.';
      container.appendChild(emptyMessage);
      return;
    }

    var list = document.createElement('ul');
    list.className = 'cc-category-filter__list';
    list.setAttribute('role', 'list');

    groups.forEach(function (parent) {
      var parentItem = document.createElement('li');
      var parentRow = document.createElement('div');
      var children = Array.from(parent.children.values()).sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
      parent.filterValue = Array.from(parent.filterIds).sort().join('__');
      var parentIsActive = isActiveCategory(activeValues, parent.filterValue);
      var childIsActive = children.some(function (child) {
        return isActiveCategory(activeValues, child.id);
      });

      parentItem.className = 'cc-category-filter__parent' + (childIsActive ? ' is-open' : '');
      parentRow.className = 'cc-category-filter__parent-row';
      parentRow.appendChild(createCategoryChoice(paramName, context + '-parent-' + sanitizeId(parent.id), parent, parent.count, parentIsActive));

      if (children.length) {
        var childListId = 'cc-category-children-' + context + '-' + sanitizeId(parent.id);
        var toggle = document.createElement('button');
        var childList = document.createElement('ul');

        toggle.className = 'cc-category-filter__toggle';
        toggle.type = 'button';
        toggle.setAttribute('aria-controls', childListId);
        toggle.setAttribute('aria-expanded', childIsActive ? 'true' : 'false');
        toggle.setAttribute('aria-label', 'Show subcategories for ' + parent.name);
        toggle.addEventListener('click', function () {
          var isOpen = parentItem.classList.toggle('is-open');
          toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });

        childList.id = childListId;
        childList.className = 'cc-category-filter__child-list';
        childList.setAttribute('role', 'list');

        children.forEach(function (child) {
          childList.appendChild(createCategoryChoice(paramName, context + '-child-' + sanitizeId(parent.id), child, child.count, isActiveCategory(activeValues, child.id)));
        });

        parentRow.appendChild(toggle);
        parentItem.appendChild(parentRow);
        parentItem.appendChild(childList);
      } else {
        parentItem.appendChild(parentRow);
      }

      list.appendChild(parentItem);
    });

    container.appendChild(list);
  }

  function loadCategoryFilters() {
    var containers = Array.from(document.querySelectorAll('[data-cc-category-filter]'));

    if (!containers.length) {
      return;
    }

    getCategoryData().then(function (entries) {
      containers.forEach(function (container) {
        if (container.isConnected) {
          renderCategoryFilter(container, entries);
        }
      });
    }).catch(function () {
      containers.forEach(function (container) {
        if (container.isConnected) {
          var errorMessage = document.createElement('p');
          errorMessage.className = 'cc-category-filter__status';
          errorMessage.textContent = 'Categories could not be loaded. Please refresh the page.';
          container.replaceChildren(errorMessage);
        }
      });
    });
  }

  function initialize() {
    loadCategoryFilters();
  }

  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-cc-localization-select]')) {
      event.target.form.submit();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  document.addEventListener('theme:loading:end', initialize);
}());
